<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Tabela de tipo de composição de taxas</h3>
        </div>
        <!-- Page Header - Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Tipos de composição</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <h6 class="m-0">
                  {{ pagination.TotalItems | number }}
                  {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                </h6>
              </div>
            </div>

            <!-- Table -->
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0">Código</th>
                    <th scope="col" class="border-0">Nome</th>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(compositionFeeType, index) in compositionFeeTypes"
                    :key="index"
                  >
                    <td></td>
                    <td>{{ compositionFeeType.Id }}</td>
                    <td>{{ compositionFeeType.Name }}</td>
                    <td></td>
                    <td>
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Opções
                        </button>
                        <div
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <a
                            v-if="$isAuthorize('CompositionFeeType', 'Get')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenCompositionFeeType($event, index, true)"
                          >
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>

                          <a
                            v-if="$isAuthorize('CompositionFeeType', 'Update')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenCompositionFeeType($event, index)"
                          >
                            <i class="fas fa-highlighter mr-2"></i> Editar
                          </a>

                          <a
                            v-if="$isAuthorize('CompositionFeeType', 'Delete')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="ConfirmDeleteCompositionFeeType(compositionFeeType.Name, compositionFeeType.Id)"
                          >
                            <i class="fas fa-trash-alt mr-2"></i> Remover
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="compositionFeeTypes == undefined || compositionFeeTypes == null || compositionFeeTypes.length == 0">
                    <td colspan="6">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="mFormCompositionFeeType"
      :title="modalTitle"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <loader :is-loading="loadingModal"></loader>

      <div v-if="!loadingModal">
        <d-form-row>
          <d-col v-if="isSeeing" md="3" class="form-group">
            <label>Código</label>
            <d-form-input
              type="text"
              v-model="infoCompositionFeeType.Id"
              :disabled="isSeeing"
            />
          </d-col>

          <d-col :md="isSeeing ? '9': '12'" class="form-group">
            <label>Nome</label>
            <d-form-input
              type="text"
              v-model="infoCompositionFeeType.Name"
              :disabled="isSeeing"
            />
          </d-col>
        </d-form-row>
      </div>

      <template slot="modal-footer" slot-scope="{ cancel }">
        <b-button size="sm" @click="cancel()">Fechar</b-button>

        <b-button
          size="sm"
          variant="success"
          @click="SaveCompositionFeeType()"
          v-if="!isSeeing || (isSeeing && loadingAddUpdate)"
          :disabled="loadingAddUpdate || loadingModal"
        >
          <template v-if="!loadingAddUpdate">
            {{ pOpened != null ? " Salvar" : " Adicionar" }}
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingAddUpdate"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="12" class="form-group">
          <input
            placeholder="Nome"
            type="text"
            class="form-control"
            v-model="filter.Name"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
      </d-form-row>

      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <a
      v-if="$isAuthorize('CompositionFeeType', 'Add')"
      href="#"
      class="btn-float success"
      v-b-tooltip.hover
      title="Novo tipo de composição de taxa"
      v-on:click="OpenNewCompositionFeeType()"
    >
      <i class="fa fa-plus"></i>
    </a>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
import decimalField from "../common/decimal-field.vue";

export default {
  name: "composition-fee-type",
  components: {
    decimalField
  },
  data: function () {
    return {
      loadingList: false,
      loadingModal: false,
      loadingAddUpdate: false,
      modalTitle: "Detalhes do tipo de composição",
      idCompositionFeeType: 0,
      compositionFeeTypes: [],
      infoCompositionFeeType: {
        Id: 0,
        Name: null
      },
      countFilter: 0,
      filter: {
        Name: null,
      },
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
        TotalAmount: 0,
      },
      isSeeing: false,
      pOpened: null,
    };
  },
  watch: {
    "pagination.PageNumber": function () {
      this.ListCompositionFeeTypes();
    },
    "pagination.RowsPerPage": function () {
      this.ListCompositionFeeTypes();
    }
  },
  mounted() {
    this.ListCompositionFeeTypes();
  },
  methods: {
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListCompositionFeeTypes();
    },
    OpenCompositionFeeType: function (e, i, view) {
      e.preventDefault();
      this.loadingAddUpdate = false;
      this.ResetInfoCompositionFeeType();

      if (view == undefined && i != undefined) {
        this.pOpened = i;
        this.idCompositionFeeType = this.compositionFeeTypes[i].Id;
        this.isSeeing = false;
        this.modalTitle = "Editar tipo de composição";
        this.GetCompositionFeeType();
      } else {
        this.pOpened = null;
        this.idCompositionFeeType = this.compositionFeeTypes[i].Id;
        this.isSeeing = true;
        this.modalTitle = "Detalhes do tipo de composição";
        this.GetCompositionFeeType();
      }
      this.$bvModal.show("mFormCompositionFeeType");
    },
    ResetInfoCompositionFeeType: function () {
      this.infoCompositionFeeType = {
        Id: 0,
        Name: null
      };
    },
    SaveCompositionFeeType: function () {
      this.loadingAddUpdate = true;

      if (this.pOpened == null) {
        this.$store
          .dispatch("AddCompositionFeeType", this.infoCompositionFeeType)
          .then(() => {
            this.$makeToast(
              "Suas modificações foram salvas na base de dados.",
              "success",
              "Tipo de Composição"
            );
            this.ListCompositionFeeTypes();
            this.$bvModal.hide("mFormCompositionFeeType");
          })
          .catch((error) => {
            this.$makeToast(
              undefined,
              "danger",
              "Erro ao atualizar o tipo de composição",
              error
            );
          })
          .finally(() => {
            this.loadingAddUpdate = false;
            this.isSeeing = false;
          });
      } else {
        this.$store
          .dispatch("UpdateCompositionFeeType", this.infoCompositionFeeType)
          .then(() => {
            this.$makeToast(
              "Suas modificações foram salvas na base de dados.",
              "success",
              "Tipo de Composição"
            );
            this.ListCompositionFeeTypes();
            this.$bvModal.hide("mFormCompositionFeeType");
          })
          .catch((error) => {
            this.$makeToast(
              undefined,
              "danger",
              "Erro ao atualizar o tipo de composição",
              error
            );
          })
          .finally(() => {
            this.loadingAddUpdate = false;
            this.isSeeing = false;
          });
      }
    },
    GetCompositionFeeType: function () {
      if (this.idCompositionFeeType != 0) {
        this.loadingModal = true;
        this.$store
          .dispatch("GetCompositionFeeType", { id: this.idCompositionFeeType })
          .then((response) => {
            this.infoCompositionFeeType = response;
          })
          .catch((error) => {
            this.$makeToast(
              undefined,
              "danger",
              "Erro ao buscar o tipo de composição",
              error
            );
          })
          .finally(() => {
            this.loadingModal = false;
          });
      }
    },
    ListCompositionFeeTypes: function () {
      this.countFilter = 0;
      if (hasValue(this.filter.Name)) {
        this.countFilter++;
      }
      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          "Object.Name": this.filter.Name,
        }
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListCompositionFeeTypes", { params: data })
        .then((response) => {
          this.compositionFeeTypes = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao listar os tipos de composição",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },
    DeleteCompositionFeeType: function(id) {
      this.loadingList = true;
      this.$store.dispatch("DeleteCompositionFeeType", { id: id })
        .then(() => {
          this.$makeToast("O tipo de composição foi removido com sucesso.", "success", "Tipo de composição removido");
          this.ListCompositionFeeTypes();
          this.$bvModal.hide("mFormCompositionFeeType");
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao remover o tipo de composição", error);
        })
        .finally(() => (this.loadingList = false));
    },
    ResetFilter: function () {
      this.filter = {
        Name: null
      };
      this.ListCompositionFeeTypes();
    },
    OpenNewCompositionFeeType: function () {
      this.ResetInfoCompositionFeeType();
      this.isSeeing = false;
      this.pOpened = null;
      this.modalTitle = "Novo tipo de composição";
      this.$bvModal.show("mFormCompositionFeeType");
    },
    ConfirmDeleteCompositionFeeType: function(description, id) {
      this.$makeMsgBox("Você tem certeza que deseja remover o tipo de composição " + description + "?", "Confirmar", this.DeleteCompositionFeeType, id);
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/compositionFeeType.vue